import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useRecomendedShops } from "../../../hooks/useInfluencer";
import { getInitials } from "../../../util/text";
import s from "./ShopEmpty.module.css";
import SubscribeForm from "./SubscribeForm.jsx";

function Recommendations({ route }) {
  const { influencers, isLoading } = useRecomendedShops({ route });

  if (isLoading || !influencers || influencers.length === 0) return null;

  return (
    <div className={s.recommendations}>
      <h3 className={s.recommendationsHeading}>You might also like</h3>
      <div className={s.recommendationsList}>
        {influencers.slice(0, 6).map((shop) => (
          <Link key={shop.route} to={`/${shop.route}`} className={s.card}>
            {shop.avatar_url ? (
              <img className={s.avatar} src={shop.avatar_url} alt="" />
            ) : (
              <span className={s.avatarFallback} aria-hidden="true">
                {getInitials(shop.name)}
              </span>
            )}
            <div className={s.cardText}>
              <div className={s.cardName}>{shop.name}</div>
              <div className={s.cardLabel}>Shop</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

Recommendations.propTypes = {
  route: PropTypes.string.isRequired,
};

export default function ShopEmpty({ influencerName, influencerId, route }) {
  return (
    <section className={s.root} aria-label="Empty shop">
      <div>
        <h2 className={s.heading}>
          {influencerName
            ? `${influencerName}'s shop has no items available right now`
            : "This shop has no items available right now"}
        </h2>
        <p className={s.subtext}>
          Check back soon — new products may be added at any time.
        </p>
      </div>

      <SubscribeForm influencerId={influencerId} />
      <Recommendations route={route} />
    </section>
  );
}

ShopEmpty.propTypes = {
  influencerName: PropTypes.string,
  influencerId: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
};
